export default __webpack_public_path__ + "static/media/andyTerry.d78b04ea.jpg";